import { usePublicLegalPage } from "@/features/legal-pages/hooks";
import { NotFound } from "@/pages/NotFound";
import { PublicError, PublicLoading } from "@/pages/public/PublicState";
import { CyberPanel } from "@/components/ui/CyberPanel";
import { MarkdownContent } from "@/components/content/MarkdownContent";
import { SEO } from "@/components/seo/SEO";

export function LegalPage({ slug }: { slug: string }) {
  const page = usePublicLegalPage(slug);
  if (page.isLoading) return <PublicLoading />;
  if (page.isError) {
    const error = page.error as { status?: number };
    if (error.status === 404) return <NotFound />;
    return <PublicError />;
  }

  return (
    <section className="mx-auto w-full max-w-5xl px-3 py-8 sm:px-6 sm:py-16 lg:px-8">
      <SEO title={page.data?.title} description={`${page.data?.title ?? "Legal"} page`} robotsIndex={false} robotsFollow />
      <CyberPanel>
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-teal-200 sm:text-sm sm:tracking-[0.28em]">Legal</p>
        <h1 className="mt-3 break-words font-display text-3xl font-bold uppercase text-white sm:text-4xl">{page.data?.title}</h1>
        <p className="mt-2 text-sm text-content-muted">Updated {page.data?.updatedAt ? new Date(page.data.updatedAt).toLocaleDateString() : ""}</p>
        <MarkdownContent content={page.data?.content ?? ""} />
      </CyberPanel>
    </section>
  );
}
